export type CustomizationSource = 'ai' | 'manual'

export const DEFAULT_BRAND_TONE =
  'Generate messages in a friendly, helpful, and precise tone.'

export interface OrderingErrorMessagesState {
  customizations: Record<string, string | null>
  initialCustomizations: Record<string, string | null>
  customizationSources: Record<string, CustomizationSource>
  initialCustomizationSources: Record<string, CustomizationSource>
  lastUsedBrandTone: string
  aiModal: {
    isOpen: boolean
    brandTone: string
  }
  pendingAiSuggestions: Record<string, string>
  preAiCustomizations: Record<string, string | null> | null
  generatingCategoryIds: string[]
  pendingSingleCategoryId: string | null
}
